// resources/js/React/Components/Main/ShareBanner.js
import React, { useState } from 'react';
import styled from 'styled-components';
import ShareModal from './ShareModal';

const DISMISSED_KEY = 'muze_share_banner_dismissed';

const safeGetStorage = (key) => {
    try { return localStorage.getItem(key); } catch (e) { return null; }
};
const safeSetStorage = (key, value) => {
    try { localStorage.setItem(key, value); } catch (e) { /* ignored */ }
};

const Banner = styled.div`
    background: #5562C0;
    padding: 14px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
`;

const BannerText = styled.div`
    color: white;
    font-family: 'Effra', sans-serif;
    font-size: 15px;
`;

const BannerHeading = styled.span`
    font-weight: 600;
`;

const BannerSubtext = styled.span`
    opacity: 0.85;
    margin-left: 10px;
    font-size: 13px;
`;

const BannerActions = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    flex-shrink: 0;
`;

const ShareButton = styled.button`
    background: white;
    color: #5562C0;
    padding: 6px 18px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 13px;
    border: 0;
    cursor: pointer;
    white-space: nowrap;
    font-family: 'Effra', sans-serif;
`;

const DismissButton = styled.button`
    background: transparent;
    border: 0;
    color: rgba(255, 255, 255, 0.6);
    font-size: 20px;
    cursor: pointer;
    line-height: 1;
    padding: 0 4px;
`;

export default function ShareBanner({ isInstructor }) {
    const [dismissed, setDismissed] = useState(
        () => safeGetStorage(DISMISSED_KEY) === 'true'
    );
    const [modalOpen, setModalOpen] = useState(false);

    if (dismissed) return null;

    const handleDismiss = () => {
        safeSetStorage(DISMISSED_KEY, 'true');
        setDismissed(true);
    };

    const heading = isInstructor
        ? '🎵 Loving Muze? Help it grow.'
        : '🎵 Enjoying Muze?';

    const subtext = isInstructor
        ? 'Share it with a fellow teacher or your students.'
        : 'Invite a friend who wants to learn an instrument.';

    return (
        <>
            <Banner>
                <BannerText>
                    <BannerHeading>{heading}</BannerHeading>
                    <BannerSubtext>{subtext}</BannerSubtext>
                </BannerText>
                <BannerActions>
                    <ShareButton onClick={() => setModalOpen(true)}>
                        Share Muze
                    </ShareButton>
                    <DismissButton onClick={handleDismiss} aria-label="Dismiss">
                        ×
                    </DismissButton>
                </BannerActions>
            </Banner>

            {modalOpen && (
                <ShareModal
                    isInstructor={isInstructor}
                    onClose={() => setModalOpen(false)}
                />
            )}
        </>
    );
}
